import type { State, SetState } from './types';
import { Field, InputField, eventToState } from '../form-helpers';
import { AutosizeText } from '@components/autosize-text';

type Props = {
  state: State;
  setState: SetState;
};

export function DetailsTab({ state, setState }: Props) {
  return (
    <div class="flex flex-col gap-8 max-w-2xl">
      <InputField
        name="name"
        title="Title"
        autoFocus={state.isNew}
        value={state.name}
        onInput={eventToState(setState)}
        placeholder="e.g. Intake form"
        inputWidth="w-96 max-w-full"
      />
      <Field name="description" title="Description">
        <AutosizeText
          name="description"
          containerClass="bg-white"
          class="ruz-input min-h-20 p-3 px-4"
          placeholder="Provide a brief description of the form's purpose for the attendee"
          value={state.description}
          onInput={eventToState(setState)}
        />
      </Field>
    </div>
  );
}
